import styled from 'styled-components'
import CardTitle from '../../../../common/styles/CardTitle'
import useTopPublishers from '../hooks/useTopPublishers'
import LoadingBar from '../../../../common/LoadingBar'
import NoContent from '../../../../common/NoContent'
import {useState} from 'react'
import booksitoutIcon from '../../../../config/BooksitoutIcon'

const PublisherLogo = ({src}: {src: string | null}) => {
	const [failed, setFailed] = useState(false)

	if (!src || failed) return (
		<LogoPlaceholder>
			<booksitoutIcon.building size={18} />
		</LogoPlaceholder>
	)
	return <Logo src={src} alt={''} onError={() => setFailed(true)}/>
}

const BookStatisticsTopPublishersCard = () => {
	const [data, isLoading] = useTopPublishers()

	return (
		<Container>
				<CardTitle icon={null} mb={0} title={'출판사 TOP 10'} url={''} textSize={5}/>

				{isLoading ? (
					<RankList>
						{Array.from({length: 10}).map((_, i) => (
							<LoadingItem key={i}>
								<Rank>{i + 1}</Rank>
								<LoadingImage/>
								<LoadingBar size={3}/>
							</LoadingItem>
						))}
					</RankList>
				) : data && data.publishers.length > 0 ? (
					<RankList>
						{data.publishers.map((item, index) => {
							const content = (
								<>
									<Rank>{index + 1}</Rank>
									<PublisherLogo src={item.publisher.logoImageUrl}/>
									<Name className={'clamp-1-line'}>{item.publisher.name}</Name>
									<Count>{item.count}권</Count>
								</>
							)

							return item.publisher.urlName ? (
								<RankLink key={index} href={`/book/publisher/${item.publisher.urlName}`}>
									{content}
								</RankLink>
							) : (
								<RankItem key={index}>
									{content}
								</RankItem>
							)
						})}
					</RankList>
				) : (
					<CenterContainer>
						<NoContent message={'데이터가 없어요'}/>
					</CenterContainer>
				)}
		</Container>
	)
}

const Container = styled.div`
	height: 100%;
	background-color: var(--card-bg-color);
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
	padding: 25px;
	display: flex;
	flex-direction: column;
`

const CenterContainer = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
`

const LoadingItem = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px 8px;
	border-bottom: 1px solid var(--hover-bg-color);

	&:last-child {
		border-bottom: none;
	}
`

const LoadingImage = styled.div`
	width: 42px;
	height: 42px;
	border-radius: 50%;
	margin-right: 6px;
	background-color: var(--hover-bg-color);
`

const RankList = styled.div`
	display: flex;
	flex-direction: column;
`

const rankItemStyles = `
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px 8px;
	border-bottom: 1px solid var(--hover-bg-color);

	&:last-child {
		border-bottom: none;
	}

	&:hover {
		background-color: var(--hover-bg-color);
	}
`

const RankItem = styled.div`
	${rankItemStyles}
`

const RankLink = styled.a`
	${rankItemStyles}
	text-decoration: none;
	color: inherit;
`

const Rank = styled.span`
	min-width: 24px;
	font-weight: bold;
	color: var(--sub-text-color);
	text-align: center;
`

const Logo = styled.img`
	width: 42px;
	height: 42px;
	object-fit: contain;
	border-radius: 50%;
	margin-right: 6px;
	background-color: var(--hover-bg-color);
`

const LogoPlaceholder = styled.div`
	width: 42px;
	height: 42px;
	border-radius: 50%;
	margin-right: 6px;
	background-color: var(--hover-bg-color);
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--sub-text-color);
`

const Name = styled.span`
	flex: 1;
	color: var(--text-color);
`

const Count = styled.span`
	color: var(--sub-text-color);
	font-size: 14px;
	white-space: nowrap;
`

export default BookStatisticsTopPublishersCard
